/**
 * The key App.vue gives its top-level `<RouterView>` (module-to-module navigation forces a
 * clean remount of the page instead of patching the previous module's tree).
 */
/** The route fields {@link appViewKey} reads (a loaded or a resolved route). */
export interface ViewKeyRoute {
  name?: unknown;
  params: Readonly<Record<string, unknown>>;
  matched: readonly { path: string }[];
}

/**
 * - A nested module (a parent route with children, e.g. `/pay` → `PayModuleRoot`) is keyed
 *   by its parent path, so moving between its children keeps the module layout (header +
 *   pills) mounted; the module root keys its own inner view by name + detail id.
 * - Any other route: its name, plus the detail id (`:id` / `:payrollId`) when present, so a
 *   same-route id swap remounts the page.
 * @param route - The current route.
 * @returns The view key.
 */
export function appViewKey(route: ViewKeyRoute): string {
  const parent = route.matched.length > 1 ? route.matched[0] : undefined;
  if (parent) return `module::${parent.path}`;
  const name = String(route.name ?? '');
  const id = route.params['id'] ?? route.params['payrollId'] ?? '';
  return id ? `${name}::${String(id)}` : name;
}
